// extracted by mini-css-extract-plugin
export var cartContainer = "_pf-4";
export var gray = "_pf-1";
export var itemContainer = "_pf-2";
export var itemDetails = "_pf-3";
export var strong = "_pf-0";